import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class HeaderService {
  private headers: HttpHeaders;

  constructor() {
    this.headers = new HttpHeaders();
  }

  saveHeaders(headers: HttpHeaders): void {
    this.headers = headers;
  }

  getHeaders(): HttpHeaders {
    return this.headers;
  }
}
